import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

export enum SelectedShippingRateSetBy {
  USER = "user",
  LEARNING = "learning",
  AUTOMATIONS = "automations",
  DEFAULT_CHEAPEST = "default_cheapest",
  CHECKOUT_RATE_PURCHASED = "checkout_rate_purchased",
}

const SelectedShippingRateSetByInfoSchema_ = z.object({
  selectedShippingRateUserId: zExt
    .objectId()
    .nullish()
    .meta({ privacy: privacy.nonPii }),
  selectedShippingRateAutomationId: zExt
    .objectId()
    .nullish()
    .meta({ privacy: privacy.nonPii }),
  selectedShippingRateAutomationName: z
    .string()
    .meta({ privacy: privacy.nonPii })
    .nullish(),
});
export const SelectedShippingRateSetByInfoSchema: z.ZodType<SelectedShippingRateSetByInfo> =
  SelectedShippingRateSetByInfoSchema_;

export interface SelectedShippingRateSetByInfo extends z.infer<
  typeof SelectedShippingRateSetByInfoSchema_
> {}
